import useGet from './use-get'
import useCreate from './use-create'
import useGetFoundersReport from './use-get-founders-report'
import useGetMarketCapacityReport from './use-get-market-capacity-report'
import useGetMarketResultsReport from './use-get-market-results-report'
import useGetSeoReport from './use-get-seo-report'
import useGetOne from './use-get-one'
import useGetStatistics from './use-get-statistics'
import useGetProjectFiles from './use-get-project-files'
import useGetProjectMembers from './use-get-project-members'
import useGetProjectCase from './use-get-project-case'
import useGetProjectBriefAnswers from './use-get-project-brief-answers'
import useGetProjectSearch from './use-get-project-search'
import useGetUserSearch from './use-get-user-search'
import useUpdateProject from './use-update-project'
import useUpdateProjectBriefAnswer from './use-update-project-brief-answer'
import useUploadProjectFile from './use-upload-project-file'
import useGetMetrics from './use-get-metrics'
import useCreateGrowthPointBasics from './use-create-growth-point-basics'
import useGetGrowthPoints from './use-get-growth-points'
import useGetUploadFileTypes from './use-get-upload-file-types'
import useCreateUploadedFile from './use-create-uploaded-file'

const queries = {
  useGet,
  useCreate,
  useGetFoundersReport,
  useGetMarketCapacityReport,
  useGetMarketResultsReport,
  useGetSeoReport,
  useGetOne,
  useGetStatistics,
  useGetProjectFiles,
  useGetProjectMembers,
  useGetProjectCase,
  useGetProjectBriefAnswers,
  useGetProjectSearch,
  useGetUserSearch,
  useUpdateProject,
  useUpdateProjectBriefAnswer,
  useUploadProjectFile,
  useGetMetrics,
  useCreateGrowthPointBasics,
  useGetGrowthPoints,
  useGetUploadFileTypes,
  useCreateUploadedFile,
}

export default queries
